import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"
import { Personalize as UFPersonalize } from "@uniformdev/context-react"

const Parag = styled.p`
  padding-top: 3rem;
  color: #737373;
`

function Variation({ paragraph }) {
  return <Parag dangerouslySetInnerHTML={{ __html: paragraph }} />
}

export default function P13N(props) {
  const console = useConsole()
  const variations = props.legal_agec.reduce((variations, variation, i) => {
    const {
      criteria: { name: pz = null },
      paragraph,
    } = variation
    !!paragraph && variations.push(Object.assign({ paragraph }, pz && { pz }))
    return variations.sort((a, b) => +!!b?.pz - +!!a?.pz) /** move default variant at the end of the array */
  }, [])

  return <UFPersonalize variations={variations} component={Variation} />
}
